<template>
  <div>
    <page-list
      :list="list"
      :columns="columns"
      :singleActions="singleActions"
      :exportDataOptions="exportDataOptions" />
    <a ref="exportButton" download :id="downloadId" v-show="false" />
  </div>
</template>

<script>
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'
import expectStatus from '@/constants/expectStatus'
import { getNameFilter } from '@/utils/common/tableFilter'
import ColumnsMixin from '../mixins/columns'
import SingleActionsMixin from '../mixins/singleActions'

export default {
  name: 'OfflineExportsList',
  components: {
  },
  mixins: [WindowsMixin, ListMixin, ColumnsMixin, SingleActionsMixin],
  props: {
    id: String,
  },
  data () {
    const filterOptions = {
      name: getNameFilter(),
    }
    return {
      list: this.$list.createList(this, {
        id: this.id,
        resource: 'offline_exports',
        apiVersion: 'v1',
        getParams: this.getParams,
        filterOptions,
        hiddenColumns: [],
        steadyStatus: Object.values(expectStatus.offlineExport).flat(),
      }),
    }
  },
  computed: {
    exportDataOptions () {
      return {
        title: this.$t('common.offline_export'),
        downloadType: 'local',
        items: this.columns,
      }
    },
  },
  watch: {
  },
  created () {
    this.fetchData()
  },
  methods: {
    getParams () {
      const ret = {
        admin: this.$store.getters.isAdminMode,
      }
      return ret
    },
    fetchData () {
      this.list.fetchData()
    },
    handleOpenSidepage (row) {
      this.sidePageTriggerHandle(this, 'OfflineExportSidePage', {
        id: row.id,
        getParams: this.getParam,
        resource: () => {
          return {
            data: row,
          }
        },
      }, {
        list: this.list,
        tab: 'event-drawer',
      })
    },
  },
}
</script>
